(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-button"] && !Shopify.designMode) return;
  try {
    (function() {
    var buttons = document.querySelectorAll('[data-back-button]');
    if (buttons.length === 0) return;

    var threshold = window.innerHeight;
    var footerInView = false;

    /* Hide the button once the footer comes into view (so it never floats over
       the footer), and bring it back when you scroll up away from it. */
    var footer = document.querySelector('.footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        footerInView = entries[0].isIntersecting;
        checkScroll();
      }).observe(footer);
    }

    function checkScroll() {
      var visible = window.scrollY > threshold && !footerInView;
      buttons.forEach(function(btn) {
        btn.classList.toggle('is-visible', visible);
      });
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["studio-availability"] && !Shopify.designMode) return;
  try {
    (function () {
    var WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

    // True when the studio is open: Mon–Fri within [open, close) in its timezone.
    // On any failure we assume open so the phone link always works as a fallback.
    function isWithinHours(el) {
      var tz = el.getAttribute('data-tz') || 'America/New_York';
      var openHour = parseInt(el.getAttribute('data-open-hour'), 10);
      var closeHour = parseInt(el.getAttribute('data-close-hour'), 10);
      if (isNaN(openHour) || isNaN(closeHour)) return true;

      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).formatToParts(new Date());

        var map = {};
        parts.forEach(function (p) {
          map[p.type] = p.value;
        });

        if (WEEKDAYS.indexOf(map.weekday) === -1) return false;

        var hour = parseInt(map.hour, 10) % 24;
        var minute = parseInt(map.minute, 10);
        var minutes = hour * 60 + minute;
        return minutes >= openHour * 60 && minutes < closeHour * 60;
      } catch (e) {
        return true;
      }
    }

    function fireAnalytics() {
      var name = 'header_phone_click';
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: name });
        }
        if (typeof window.gtag === 'function') {
          window.gtag('event', name);
        }
        document.dispatchEvent(new CustomEvent('fk:analytics', { detail: { event: name } }));
      } catch (e) {}
    }

    function closeAll(except) {
      document.querySelectorAll('.studio-availability-wrap.is-open').forEach(function (w) {
        if (w !== except) w.classList.remove('is-open');
      });
    }

    function init() {
      document.querySelectorAll('[data-studio-availability]').forEach(function (el) {
        var wrap = el.closest('.studio-availability-wrap');

        el.addEventListener('click', function (e) {
          // Outside studio hours: don't dial an unanswered line — surface the
          // after-hours email tooltip instead.
          if (wrap && !isWithinHours(el)) {
            e.preventDefault();
            var willOpen = !wrap.classList.contains('is-open');
            closeAll(wrap);
            wrap.classList.toggle('is-open', willOpen);
            return;
          }
          fireAnalytics();
        });
      });

      // Dismiss on outside click.
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.studio-availability-wrap.is-open')) {
          closeAll(null);
        }
      });

      // Dismiss on Escape.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll(null);
      });
    }

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["thinking-orb"] && !Shopify.designMode) return;
  try {
    /* thinking-orbs — vanilla port of Jakub Antalik's MIT-licensed package.
     Original: https://github.com/Jakubantalik/thinking-orbs */
  (function () {
    /* ── pure math helpers (unchanged from the original engine) ── */
    function rand(i, seed) {
      var s = Math.sin(i * 12.9898 + seed * 78.233) * 43758.5453;
      return s - Math.floor(s);
    }
    function fib(i, n) {
      var s = Math.PI * (3 - Math.sqrt(5)), r = 1 - 2 * (i + 0.5) / n,
          t = Math.sqrt(1 - r * r), o = i * s;
      return [t * Math.cos(o), r, t * Math.sin(o)];
    }
    function angDiff(a, b) { return Math.atan2(Math.sin(a - b), Math.cos(a - b)); }
    /* Build a project(x,y,z) => [screenX, screenY, depth] for a given yaw/pitch. */
    function makeProj(yaw, pitch, cx, cy, rad) {
      var so = Math.sin(pitch), co = Math.cos(pitch), sa = Math.sin(yaw), ca = Math.cos(yaw);
      return function (mx, my, mz) {
        var u = mx * ca + mz * sa, h = -mx * sa + mz * ca,
            b = my * co - h * so, x = my * so + h * co;
        return [cx + u * rad, cy - b * rad, x];
      };
    }
    /* Painter's-algorithm dot draw: sort back-to-front, grayscale by `white`. */
    function drawDots(ctx, pts, dark, rMin) {
      rMin = rMin == null ? 0.3 : rMin;
      /* A solid override color (set once per canvas in mountOrb) wins over the
         grayscale theme shading; per-dot depth alpha is still applied. */
      var solid = ctx.__orbColor;
      pts.sort(function (a, b) { return a.z - b.z; });
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i], alpha = p.a == null ? 1 : p.a;
        if (alpha < 0.02) continue;
        if (solid) {
          ctx.globalAlpha = alpha;
          ctx.fillStyle = solid;
        } else {
          var c = Math.min(1, Math.max(0, p.white)), v = Math.round((dark ? 1 - c : c) * 255);
          ctx.fillStyle = 'rgba(' + v + ',' + v + ',' + v + ',' + alpha + ')';
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y, Math.max(rMin, p.r), 0, Math.PI * 2);
        ctx.fill();
      }
      if (solid) ctx.globalAlpha = 1;
    }
    function rScale(size, pow) { return Math.pow(size / 300, pow); }
    function smoothstep(e) { return e * e * (3 - 2 * e); }

    /* ── rubik move scheduling ── */
    function moveSchedule(time, count, step, gap) {
      var period = 2 * count * step + gap, o = time % period, amount = new Array(count), active = -1;
      for (var z = 0; z < count; z++) amount[z] = 0;
      if (o < 2 * count * step) {
        var i = Math.floor(o / step), m = (o - i * step) / step, M = 1 - Math.pow(1 - Math.min(1, m / 0.7), 3);
        if (i < count) { for (var u = 0; u < i; u++) amount[u] = 1; amount[i] = M; active = i; }
        else { var uu = 2 * count - 1 - i; for (var h = 0; h < uu; h++) amount[h] = 1; amount[uu] = 1 - M; active = uu; }
      }
      return { amount: amount, active: active };
    }
    function applyMoves(vec, moves, sched) {
      var r = vec[0], t = vec[1], o = vec[2], hit = false;
      for (var a = 0; a < moves.length; a++) {
        if (sched.amount[a] <= 0) continue;
        var mv = moves[a], m = mv.axis === 0 ? r : mv.axis === 1 ? t : o;
        if (m < mv.lo || m >= mv.hi) continue;
        if (a === sched.active) hit = true;
        var g = mv.ang * sched.amount[a], M = Math.cos(g), u = Math.sin(g), hh;
        if (mv.axis === 0) { hh = t * M - o * u; o = t * u + o * M; t = hh; }
        else if (mv.axis === 1) { hh = r * M + o * u; o = -r * u + o * M; r = hh; }
        else { hh = r * M - t * u; t = r * u + t * M; r = hh; }
      }
      return [r, t, o, hit];
    }
    function genMoves(count) {
      var n = [];
      for (var s = 0; s < count; s++) {
        var r = Math.min(2, Math.floor(rand(s, 2.3) * 3)),
            t = -1 + 0.5 * Math.min(3, Math.floor(rand(s, 5.9) * 4)),
            o = rand(s, 7.7) < 0.5 ? 1 : -1;
        n.push({ axis: r, lo: t, hi: t + 0.5, ang: o * Math.PI / 2 });
      }
      return n;
    }

    /* ── morph shape sampler ── */
    function pathSampler(pts) {
      var n = pts.length, seg = [], total = 0;
      for (var t = 0; t < n; t++) {
        var o = pts[t], c = pts[(t + 1) % n], a = Math.hypot(c[0] - o[0], c[1] - o[1]);
        seg.push(a); total += a;
      }
      return function (u) {
        var o = u * total, c = 0;
        while (o > seg[c] && c < n - 1) { o -= seg[c]; c++; }
        var a = pts[c], i = pts[(c + 1) % n], m = seg[c] ? Math.min(1, o / seg[c]) : 0;
        return [a[0] + (i[0] - a[0]) * m, a[1] + (i[1] - a[1]) * m];
      };
    }
    var circle = function (u) { var n = -Math.PI / 2 + u * 2 * Math.PI; return [Math.cos(n) * 0.24, Math.sin(n) * 0.24]; };
    var triangle = pathSampler([[0, -0.26], [0.24, 0.16], [-0.24, 0.16]]);
    var square = pathSampler([[0, -0.2], [0.2, -0.2], [0.2, 0.2], [-0.2, 0.2], [-0.2, -0.2]]);
    var SHAPES = [circle, triangle, square];
    function morphDotCount(e) { return Math.max(6, Math.round(34 * e)); }
    var MORPH_HOLD = 1.4, MORPH_TRANS = 0.9, MORPH_CYCLE = MORPH_HOLD + MORPH_TRANS;

    /* ── the six draws ── */
    function drawGlobe(ctx, size, time, dark, o) {
      var cx = size / 2, cy = size / 2, rad = size / 2 * 0.82,
          pitch = 0.4 + 0.06 * Math.sin(time * 0.35),
          proj = makeProj(time * 0.5, pitch, cx, cy, rad),
          scan = time * (0.5 + 1.2 * (o.scanMul == null ? 1 : o.scanMul)),
          u = rScale(size, o.rsPow == null ? 0.6 : o.rsPow),
          dimBase = o.dimBase == null ? 1 : o.dimBase, pts = [],
          latRings = o.latRings == null ? 17 : o.latRings, lon = o.lonDensity == null ? 44 : o.lonDensity;
      for (var P = 0; P <= latRings; P++) {
        var lat = -Math.PI / 2 + P / latRings * Math.PI, cl = Math.cos(lat), sl = Math.sin(lat),
            k = Math.max(1, Math.round(Math.abs(cl) * lon));
        for (var v = 0; v < k; v++) {
          var ln = v / k * 2 * Math.PI, pr = proj(cl * Math.cos(ln), sl, cl * Math.sin(ln)),
              f = (pr[2] + 1) / 2, sa = angDiff(ln + time * 0.5, scan),
              L = Math.exp(-(sa * sa) / 0.18) * Math.max(0, pr[2]);
          pts.push({ x: pr[0], y: pr[1], z: pr[2],
            r: ((o.rBase == null ? 0.6 : o.rBase) + (o.rDepth == null ? 1.7 : o.rDepth) * f + (o.rBoost == null ? 1 : o.rBoost) * L) * u,
            white: (o.inkFar == null ? 0.62 : o.inkFar) - (o.inkSpan == null ? 0.54 : o.inkSpan) * f,
            a: dimBase + (1 - dimBase) * Math.min(1, L) });
        }
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    function drawRubik(ctx, size, time, dark, o) {
      var cx = size / 2, cy = size / 2, rad = size / 2 * 0.82,
          proj = makeProj(time * 0.55, 0.35 + 0.1 * Math.sin(time * 0.9), cx, cy, rad),
          u = rScale(size, o.rsPow == null ? 0.6 : o.rsPow), mc = o.moveCount == null ? 14 : o.moveCount,
          moves = genMoves(mc), sched = moveSchedule(time, mc, 0.42, 1.2), pts = [],
          latRings = o.latRings == null ? 15 : o.latRings, lon = o.lonDensity == null ? 40 : o.lonDensity;
      for (var I = 0; I <= latRings; I++) {
        var lat = -Math.PI / 2 + I / latRings * Math.PI, cl = Math.cos(lat), sl = Math.sin(lat),
            w = Math.max(1, Math.round(Math.abs(cl) * lon));
        for (var k = 0; k < w; k++) {
          var ln = k / w * 2 * Math.PI, mv = applyMoves([cl * Math.cos(ln), sl, cl * Math.sin(ln)], moves, sched),
              pr = proj(mv[0], mv[1], mv[2]), f = (pr[2] + 1) / 2, hit = mv[3];
          pts.push({ x: pr[0], y: pr[1], z: pr[2],
            r: ((o.rBase == null ? 0.6 : o.rBase) + (o.rDepth == null ? 1.7 : o.rDepth) * f + (hit ? (o.rActive == null ? 0.3 : o.rActive) : 0)) * u,
            white: (o.inkFar == null ? 0.62 : o.inkFar) - (o.inkSpan == null ? 0.54 : o.inkSpan) * f - (hit ? 0.14 : 0) });
        }
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    function drawWave(ctx, size, time, dark, o) {
      var cx = size / 2, cy = size / 2, rad = size / 2 * 0.874,
          proj = makeProj(time * 0.18, 0.38, cx, cy, 1),
          u = rScale(size, o.rsPow == null ? 0.6 : o.rsPow), pts = [],
          rings = o.rings == null ? 15 : o.rings, lon = o.lonDensity == null ? 40 : o.lonDensity;
      for (var h = 0; h <= rings; h++) {
        var lat = -Math.PI / 2 + h / rings * Math.PI, cl = Math.cos(lat), sl = Math.sin(lat),
            wob = 0.62 * Math.sin(time * 2.1 - h * 0.52) + 0.38 * Math.sin(time * 1.27 + h * 0.83),
            ry = rad * (0.88 + 0.105 * wob), D = Math.max(1, Math.round(Math.abs(cl) * lon));
        for (var w = 0; w < D; w++) {
          var ln = w / D * 2 * Math.PI, pr = proj(cl * Math.cos(ln) * ry, sl * ry, cl * Math.sin(ln) * ry),
              d = (pr[2] / rad + 1) / 2, l = Math.max(0, wob);
          pts.push({ x: pr[0], y: pr[1], z: pr[2],
            r: ((o.rBase == null ? 0.6 : o.rBase) + (o.rDepth == null ? 1.7 : o.rDepth) * d) * (1 + 0.4 * l) * u,
            white: 0.66 - 0.56 * d - 0.1 * l });
        }
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    function drawMorph(ctx, size, time, dark, o) {
      var sc = SHAPES.length, c = time % (MORPH_CYCLE * sc), idx = Math.floor(c / MORPH_CYCLE),
          within = c - idx * MORPH_CYCLE,
          mt = within > MORPH_HOLD ? smoothstep((within - MORPH_HOLD) / MORPH_TRANS) : 0,
          spread = o.spread == null ? 1 : o.spread, from = SHAPES[idx], to = SHAPES[(idx + 1) % sc],
          H = 160, path = [], p, d, l, f;
      for (p = 0; p < H; p++) { d = p / H; l = from(d); f = to(d); path.push([(l[0] + (f[0] - l[0]) * mt) * spread, (l[1] + (f[1] - l[1]) * mt) * spread]); }
      var seg = [], total = 0;
      for (p = 0; p < H; p++) { var pa = path[p], pb = path[(p + 1) % H], sl = Math.hypot(pb[0] - pa[0], pb[1] - pa[1]); seg.push(sl); total += sl; }
      var dotN = morphDotCount(o.iconD == null ? 1 : o.iconD), rDot = (o.rDot == null ? 0.021 : o.rDot) * 1.35 * spread,
          pulse = 1 + 0.02 * Math.sin(within * 3.1), pts = [], half = size / 2, v = 0, acc = 0;
      for (p = 0; p < dotN; p++) {
        var target = p / dotN * total;
        while (acc + seg[v] < target && v < H - 1) { acc += seg[v]; v++; }
        var a = path[v], b = path[(v + 1) % H], s2 = seg[v] ? Math.min(1, (target - acc) / seg[v]) : 0,
            L = (a[0] + (b[0] - a[0]) * s2) * pulse, A = (a[1] + (b[1] - a[1]) * s2) * pulse;
        pts.push({ x: half + L * size, y: half + A * size, z: 0, r: Math.max(0.35, rDot * size), white: 0.1 });
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    function drawOrbits(ctx, size, time, dark, o) {
      var cx = size / 2, cy = size / 2, rad = size / 2 * 0.82,
          proj = makeProj(time * 0.12, 0.3, cx, cy, 1), u = rScale(size, o.rsPow == null ? 0.6 : o.rsPow), pts = [],
          orbitN = o.orbitN == null ? 12 : o.orbitN, ghostN = o.ghostN == null ? 40 : o.ghostN, particles = o.particles == null ? 3 : o.particles;
      for (var bi = 0; bi < orbitN; bi++) {
        var x = rand(bi, 1.7), I = rand(bi, 5.2), P = rand(bi, 8.9),
            y = rad * (0.45 + 0.52 * x), Dg = x * 2 * Math.PI, wq = Math.acos(2 * I - 1),
            kx = Math.sin(wq) * Math.cos(Dg), vv = Math.cos(wq), R = Math.sin(wq) * Math.sin(Dg),
            pp = -vv, dd = kx, ll = 0, ff = Math.max(1e-6, Math.sqrt(pp * pp + dd * dd));
        pp /= ff; dd /= ff;
        var S = vv * ll - R * dd, L = R * pp - kx * ll, A = kx * dd - vv * pp,
            B = (0.25 + 0.55 * P) * (P > 0.5 ? 1 : -1), C, E, pr, O;
        for (C = 0; C < ghostN; C++) {
          E = C / ghostN * 2 * Math.PI;
          pr = proj((pp * Math.cos(E) + S * Math.sin(E)) * y, (dd * Math.cos(E) + L * Math.sin(E)) * y, (ll * Math.cos(E) + A * Math.sin(E)) * y);
          O = (pr[2] / y + 1) / 2;
          pts.push({ x: pr[0], y: pr[1], z: pr[2], r: (o.ghostR == null ? 0.9 : o.ghostR) * u, white: 0.72, a: (o.ghostA == null ? 0.5 : o.ghostA) * (0.4 + 0.6 * O) });
        }
        for (C = 0; C < particles; C++) {
          E = time * B + C / particles * 2 * Math.PI + I * 6;
          pr = proj((pp * Math.cos(E) + S * Math.sin(E)) * y, (dd * Math.cos(E) + L * Math.sin(E)) * y, (ll * Math.cos(E) + A * Math.sin(E)) * y);
          O = (pr[2] / y + 1) / 2;
          pts.push({ x: pr[0], y: pr[1], z: pr[2], r: ((o.partR == null ? 1.2 : o.partR) + (o.partRDepth == null ? 1.6 : o.partRDepth) * O) * u, white: 0.3 - 0.22 * O });
        }
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    function drawRibbon(ctx, size, time, dark, o) {
      var cx = size / 2, cy = size / 2, rad = size / 2 * 0.78, spin = o.spin == null ? 1 : o.spin,
          proj = makeProj(time * 0.1 * spin, 0.3, cx, cy, 1), g = rScale(size, o.rsPow == null ? 0.6 : o.rsPow),
          pts = [], ghostN = o.ghostN == null ? 150 : o.ghostN, fi, S, pr, Cc;
      for (fi = 0; fi < ghostN; fi++) {
        S = fib(fi, ghostN); pr = proj(S[0] * rad, S[1] * rad, S[2] * rad); Cc = (pr[2] / rad + 1) / 2;
        pts.push({ x: pr[0], y: pr[1], z: pr[2], r: 0.8 * g, white: 0.78, a: 0.1 + 0.22 * Cc });
      }
      var hh = time * 0.24 * spin, bb = 0.55 + 0.3 * Math.sin(time * 0.18) * spin,
          x = Math.cos(hh), Ib = 0, Pb = Math.sin(hh),
          y = -Pb * Math.sin(bb), D = Math.cos(bb), w = x * Math.sin(bb),
          k = Ib * w - Pb * D, v = Pb * y - x * w, R = x * D - Ib * y,
          lanes = o.lanes == null ? 5 : o.lanes, segs = o.segs == null ? 88 : o.segs,
          l = Math.max(1, Math.round(lanes * (o.bandMul == null ? 1 : o.bandMul)));
      for (var f = 0; f < l; f++) {
        var Sf = (f - (l - 1) / 2) * 0.075, Ln = Math.abs(f - (l - 1) / 2) / Math.max(1, (l - 1) / 2);
        for (var Aa = 0; Aa < segs; Aa++) {
          var Bb = Aa / segs * 2 * Math.PI,
              Cwob = (0.16 * Math.sin(Bb * 3 - time * 1.7 + f * 0.22) + 0.07 * Math.sin(Bb * 5 + time * 1.1)) * (o.wobMul == null ? 1 : o.wobMul),
              Eb = Sf + Cwob,
              T = x * Math.cos(Bb) + y * Math.sin(Bb) + k * Eb,
              z = Ib * Math.cos(Bb) + D * Math.sin(Bb) + v * Eb,
              N = Pb * Math.cos(Bb) + w * Math.sin(Bb) + R * Eb,
              norm = Math.sqrt(T * T + z * z + N * N),
              prb = proj(T / norm * rad, z / norm * rad, N / norm * rad), j = (prb[2] / rad + 1) / 2;
          pts.push({ x: prb[0], y: prb[1], z: prb[2],
            r: ((o.rBase == null ? 1.1 : o.rBase) + (o.rDepth == null ? 1.7 : o.rDepth) * j) * (1 - 0.25 * Ln) * g,
            white: 0.52 - 0.44 * j + 0.18 * Ln, a: 0.4 + 0.6 * j });
        }
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    /* ── clean bead-morph (built from scratch) ──
       Fixed 12 dots. Each shape puts one dot on every corner and spreads the
       rest evenly along each edge. Because the polygons are REGULAR (equal
       edges) and 12 divides 3 / 4 / 6, every edge gets the same count → the
       layout is symmetric by construction (no top-heavy imbalance) and the
       corners are always crisp. All shapes share the same 12 dots, so morphing
       is a straight dot-to-dot lerp. */
    var BEAD_N = 12;
    function circleBeads(N, R) {
      var p = [];
      for (var i = 0; i < N; i++) { var a = -Math.PI / 2 + i / N * 2 * Math.PI; p.push([Math.cos(a) * R, Math.sin(a) * R]); }
      return p;
    }
    function edgeDots(corners, N) {
      var V = corners.length, perEdge = N / V, pts = [], e, k;
      for (e = 0; e < V; e++) {
        var a = corners[e], b = corners[(e + 1) % V];
        for (k = 0; k < perEdge; k++) { var t = k / perEdge; pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
      }
      return pts;
    }
    function polyBeads(N, V, R, rot) {
      var corners = [];
      for (var v = 0; v < V; v++) { var a = rot + v / V * 2 * Math.PI; corners.push([Math.cos(a) * R, Math.sin(a) * R]); }
      return edgeDots(corners, N);
    }
    /* Rotate a ring so the dot nearest top-center is index 0 — keeps every
       shape's dots aligned so the morph barely spins. */
    function startAtTop(pts) {
      var best = 0, bestScore = Infinity;
      for (var i = 0; i < pts.length; i++) {
        var score = pts[i][1] + Math.abs(pts[i][0]) * 0.5;
        if (score < bestScore) { bestScore = score; best = i; }
      }
      return pts.slice(best).concat(pts.slice(0, best));
    }
    function beadShapes(N, R) {
      return [
        startAtTop(polyBeads(N, 6, R, -Math.PI / 2)), /* hexagon, point up */
        startAtTop(polyBeads(N, 4, R, Math.PI / 4)),  /* square, axis-aligned */
        startAtTop(circleBeads(N, R)),                /* circle */
        startAtTop(polyBeads(N, 4, R, -Math.PI / 2))  /* diamond (square rotated 45°) */
      ];
    }
    function drawMorphClean(ctx, size, time, dark, o) {
      var R = o.shapeFrac == null ? 0.4 : o.shapeFrac,
          dotFrac = o.dotFrac == null ? 0.07 : o.dotFrac,
          shapes = beadShapes(BEAD_N, R), sc = shapes.length,
          c = time % (MORPH_CYCLE * sc), idx = Math.floor(c / MORPH_CYCLE),
          within = c - idx * MORPH_CYCLE,
          mt = within > MORPH_HOLD ? smoothstep((within - MORPH_HOLD) / MORPH_TRANS) : 0,
          fromPts = shapes[idx], toPts = shapes[(idx + 1) % sc],
          pulse = 1 + 0.02 * Math.sin(within * 3.1), half = size / 2,
          r = Math.max(0.5, dotFrac * size), pts = [];
      for (var i = 0; i < BEAD_N; i++) {
        var a = fromPts[i], b = toPts[i],
            x = (a[0] + (b[0] - a[0]) * mt) * pulse,
            y = (a[1] + (b[1] - a[1]) * mt) * pulse;
        pts.push({ x: half + x * size, y: half + y * size, z: 0, r: r, white: 0.1 });
      }
      drawDots(ctx, pts, dark, o.rMin);
    }
    var MODE_DRAWS = { orbits: drawOrbits, globe: drawGlobe, rubik: drawRubik, wave: drawWave, ribbon: drawRibbon, morph: drawMorph, beads: drawMorphClean };

    /* ── preset config (base opts + per-size tuning), from the original ── */
    var BASE_OPTS = {
      globe: { latRings: 17, lonDensity: 44, rBase: 0.6, rDepth: 1.7, rBoost: 1, inkFar: 0.62, inkSpan: 0.54, rsPow: 0.6, rMin: 0.3 },
      orbits: { orbitN: 12, ghostN: 40, ghostR: 0.9, ghostA: 0.5, particles: 3, partR: 1.2, partRDepth: 1.6, rsPow: 0.6, rMin: 0.3 },
      rubik: { latRings: 15, lonDensity: 40, moveCount: 14, rBase: 0.6, rDepth: 1.7, rActive: 0.3, inkFar: 0.62, inkSpan: 0.54, rsPow: 0.6, rMin: 0.3 },
      wave: { rings: 15, lonDensity: 40, rBase: 0.6, rDepth: 1.7, rsPow: 0.6, rMin: 0.3 },
      ribbon: { lanes: 5, segs: 88, ghostN: 150, rBase: 1.1, rDepth: 1.7, rsPow: 0.6, rMin: 0.3 },
      morph: { rDot: 0.021, iconD: 1, rMin: 0.25 },
      beads: { dotFrac: 0.07, shapeFrac: 0.4, rMin: 0.3 }
    };
    var PRESETS = {
      orbits: { 20: { speed: 3.9, count: 0.238, size: 2.4 }, 64: { speed: 1.885, count: 1, size: 1 } },
      globe: { 20: { speed: 2.665, count: 0.105, size: 1.75, extra: { scanMul: 4.335, dimBase: 0.45 } }, 64: { speed: 2.015, count: 0.42, size: 1.15, extra: { scanMul: 4.08, dimBase: 0.45 } } },
      rubik: { 20: { speed: 1.95, count: 0.088, size: 1.9 }, 64: { speed: 1.82, count: 0.35, size: 1.05 } },
      wave: { 20: { speed: 3.998, count: 0.105, size: 1.6 }, 64: { speed: 4.388, count: 0.341, size: 1 } },
      ribbon: { 20: { speed: 3.12, count: 0.051, size: 1.073, extra: { spin: 0, bandMul: 4.94, wobMul: 1 } }, 64: { speed: 2.34, count: 0.25, size: 0.85, extra: { spin: 0, bandMul: 3.9, wobMul: 1 } } },
      morph: { 20: { speed: 2.08, count: 0.53, size: 1.011, extra: { spread: 1.45 } }, 64: { speed: 2.405, count: 0.54, size: 0.395, extra: { spread: 1.45 } } },
      beads: { 20: { speed: 1.6, count: 1, size: 1 }, 64: { speed: 1.6, count: 1, size: 1 } }
    };
    var COUNT_PAIRS = [['latRings', 'lonDensity'], ['rings', 'lonDensity'], ['lanes', 'segs']];
    var COUNT_SINGLE = ['orbitN', 'ghostN'], COUNT_ICOND = ['iconD'];
    var SIZE_KEYS = ['rBase', 'rDepth', 'rActive', 'rDot', 'ghostR', 'partR', 'partRDepth'];
    function scaleCount(opts, n) {
      var s = {}, done = {}, t = Math.sqrt(n), key, i;
      for (key in opts) if (opts.hasOwnProperty(key)) s[key] = opts[key];
      for (i = 0; i < COUNT_PAIRS.length; i++) {
        var a = COUNT_PAIRS[i][0], b = COUNT_PAIRS[i][1];
        if (s[a] != null && s[b] != null && !done[a] && !done[b]) {
          s[a] = Math.max(2, Math.round(s[a] * t)); s[b] = Math.max(2, Math.round(s[b] * t)); done[a] = done[b] = true;
        }
      }
      for (i = 0; i < COUNT_SINGLE.length; i++) { key = COUNT_SINGLE[i]; if (s[key] != null && !done[key]) s[key] = Math.max(1, Math.round(s[key] * n)); }
      for (i = 0; i < COUNT_ICOND.length; i++) { key = COUNT_ICOND[i]; if (s[key] != null) s[key] = Math.max(0.02, s[key] * n); }
      return s;
    }
    function scaleSize(opts, n) {
      var s = {}, key, i;
      for (key in opts) if (opts.hasOwnProperty(key)) s[key] = opts[key];
      for (i = 0; i < SIZE_KEYS.length; i++) { key = SIZE_KEYS[i]; if (s[key] != null) s[key] = s[key] * n; }
      s.rSizeMul = (s.rSizeMul == null ? 1 : s.rSizeMul) * n;
      return s;
    }
    function resolvePreset(mode, sizeKey) {
      var preset = PRESETS[mode][sizeKey], opts = {}, key;
      for (key in BASE_OPTS[mode]) if (BASE_OPTS[mode].hasOwnProperty(key)) opts[key] = BASE_OPTS[mode][key];
      if (preset.count !== 1) opts = scaleCount(opts, preset.count);
      if (preset.size !== 1) opts = scaleSize(opts, preset.size);
      if (preset.extra) for (key in preset.extra) if (preset.extra.hasOwnProperty(key)) opts[key] = preset.extra[key];
      return { speed: preset.speed, opts: opts };
    }

    /* ── mount one canvas ── */
    function mountOrb(canvas) {
      var mode = canvas.getAttribute('data-orb-style');
      if (!mode || !MODE_DRAWS[mode]) return;
      var size = parseInt(canvas.getAttribute('data-orb-size'), 10) || 32,
          themeAttr = canvas.getAttribute('data-orb-theme') || 'auto',
          dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(size * dpr); canvas.height = Math.round(size * dpr);
      canvas.style.width = size + 'px'; canvas.style.height = size + 'px';
      var ctx = canvas.getContext('2d'); if (!ctx) return;
      var colorAttr = canvas.getAttribute('data-orb-color');
      if (colorAttr) ctx.__orbColor = colorAttr;
      var resolved = resolvePreset(mode, size <= 40 ? 20 : 64), speed = resolved.speed, opts = resolved.opts,
          draw = MODE_DRAWS[mode],
          dark = themeAttr === 'dark' ? true : themeAttr === 'light' ? false : (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
      function frame(time) { ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, size, size); draw(ctx, size, time, dark, opts); }

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { frame(0.6); return; }

      var rafId = 0, running = false;
      function loop() { frame(performance.now() / 1000 * speed); if (running) rafId = requestAnimationFrame(loop); }
      function start() { if (!running) { running = true; rafId = requestAnimationFrame(loop); } }
      function stop() { running = false; cancelAnimationFrame(rafId); }
      frame(performance.now() / 1000 * speed);
      var visible = true;
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        (visible && document.visibilityState !== 'hidden') ? start() : stop();
      }) : null;
      if (io) io.observe(canvas); else start();
      document.addEventListener('visibilitychange', function () {
        document.visibilityState === 'hidden' ? stop() : (visible && start());
      });
    }

    function initOrbs(root) {
      (root || document).querySelectorAll('canvas.thinking-orb[data-orb-style]').forEach(function (c) {
        if (c.__orbMounted) return; c.__orbMounted = true; mountOrb(c);
      });
    }
    if (document.readyState !== 'loading') initOrbs();
    else document.addEventListener('DOMContentLoaded', function () { initOrbs(); });
    /* Theme editor re-renders sections without a full reload. */
    document.addEventListener('shopify:section:load', function (e) { initOrbs(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
